import { useCallback, useEffect, useRef } from 'react';
import { Container } from '@pixi/react';
import { observer } from 'mobx-react-lite';

import { soundService, SoundTypes } from '../../../../../services/soundService';
import { BlackLayer } from '../../../../components/blackLayer';
import { Spine } from '../../../../components';
import { isMobile } from '../../../../../helpers';
import { useStore } from '../../../../../hooks';

export const JackPotCongratsPopup: React.FC = observer(() => {
  const jackPotCongratsPopupRef: any = useRef(null);
  const { jackpotStore } = useStore();
  const { isShowJackpotCongratsPopUp } = jackpotStore;

  useEffect(() => {
    if (isShowJackpotCongratsPopUp) {
      const jackPotCongratsPopup: Spine = new Spine({ key: 'jackpotCongratsPopup' });
      jackPotCongratsPopupRef.current.addChild(jackPotCongratsPopup);
      if (isMobile()) jackPotCongratsPopup.scale.set(Math.min(window.innerWidth / 540, window.innerHeight / 960));
      jackPotCongratsPopup.x = isMobile() ? window.innerWidth / 2 : 720;
      jackPotCongratsPopup.y = isMobile() ? window.innerHeight / 2 : 405;
    }
  }, [isShowJackpotCongratsPopUp]);

  useEffect(() => {
    if (isShowJackpotCongratsPopUp) {
      soundService.play(SoundTypes.JackpotSceneTransition);
      const popup = jackPotCongratsPopupRef.current?.children[0];
      popup.play('start');
      popup.addListener(
        'complete',
        () => {
          popup.play('loop', true);
          setTimeout(() => {
            jackPotCongratsPopupRef?.current?.children[0].play('end');
            hideJackPotCongratsPopup();
          }, 3000);
        },
        null, 'start'
      );
    }
  }, [isShowJackpotCongratsPopUp]);

  const hideJackPotCongratsPopup = useCallback(() => {
    jackPotCongratsPopupRef.current?.children[0].play('end');
    jackPotCongratsPopupRef.current?.children[0].addListener(
      'whiteEnd',
      () => {
        soundService.stop(SoundTypes.JackpotSceneTransition);
        jackpotStore.setShowJackpotCongratsPopUp(false);
        jackpotStore.setShouldPlayInitialJackpotMusic(true);
        jackpotStore.setOpenJackpotScene(true);
      },
      null, 'end'
    );
  }, [isShowJackpotCongratsPopUp]);

  if (!isShowJackpotCongratsPopUp) return null;

  return (
    <>
      {isMobile() && <BlackLayer />}
      <Container
        ref={jackPotCongratsPopupRef}
        {...({ interactive: true } as any)}
        name='JackPotCongratsPopupContainer'
      />
    </>
  );
});
